const locale = require('./activeSubmissionDropdown.i18n.json');

/*@ngInject*/
const ActiveSubmissionDropdownController = function ($scope, $state, $stateParams, submissionStatus, headerUtil, submissionStateMediator, submissionMediator, submissionConstant, coreConstant) {

    this.i18n = locale;

    this.submissionId = parseInt($stateParams.submissionId);
    this.activeSubmissionList = [];
    this.selectedSubmissionName = '';
    this.hasOpenSubmissions = false;
    this.defaultSubmissionNameLabel = this.i18n.defaultSubmissionNameLabel;

    this.$onInit = function () {
        this.updateSubmissionDropdown();
    };

    this.shouldShowCloseButton = function () {
        const numberOfActiveSubmissions = _.size(this.activeSubmissionList);

        if (numberOfActiveSubmissions === 1) {
            const activeSubmission = _.first(this.activeSubmissionList);

            if (activeSubmission.status !== submissionStatus.CREATED_SUBMISSION && this.isSelected(activeSubmission)) {
                return true;
            }
        }

        return false;
    };

    this.isActiveNavElement = function (type) {
        return headerUtil.isActiveNavElement(type);
    };

    this.switchToSelectedSubmission = function () {
        if (!_.isNil(this.submissionId)) {
            // On the home screen, so switch to submission
            const submission = this.getSelectedSubmission();
            this.onOpenSubmission(submission);
        }
    };

    this.onOpenSubmission = function (submission) {
        const stateUrl = submissionStateMediator.getSubmissionStateUrl(submission.id);

        let params = {submissionId: submission.id},
            stateName = 'submission.form';

        if (_.isPlainObject(stateUrl)) {
            params = _.get(stateUrl, 'params', params);
            stateName = _.get(stateUrl, 'name', stateName);
        }

        $state.go(stateName, params);
    };

    function handleCloseSubmission(submissionId) {
        submissionMediator.closeSubmission(submissionId);
    }

    this.onCloseSubmission = function (event, submission) {
        handleCloseSubmission(submission.id);
        event.stopPropagation();
    };

    this.getSelectedSubmission = function () {
        return _.find(this.activeSubmissionList, (submission) => {
            return this.isSelected(submission);
        });
    };

    this.isSelected = function (submission) {
        const selectedSubmission = submissionMediator.getSelectedSubmission();

        return selectedSubmission && submission.id === selectedSubmission.id;
    };

    this.updateSubmissionDropdown = function () {
        this.activeSubmissionList = _.sortBy(submissionMediator.getOpenSubmissionList(), (item) => {
            return item.lastModified;
        });

        this.hasOpenSubmissions = !_.isEmpty(submissionMediator.getOpenSubmissionList());
        this.selectedSubmissionName = this.getSelectedSubmissionName();
    };

    this.getSelectedSubmissionName = function () {
        const submission = this.getSelectedSubmission();

        let selectedSubmissionName = '';

        if (!_.isNil(submission)) {
            selectedSubmissionName = submission.submissionTabDisplayName || submission.insured.name || this.defaultSubmissionNameLabel;
        }

        return selectedSubmissionName;
    };

    $scope.$on(submissionConstant.event.OPEN_SUBMISSION_LIST_CHANGE, () => {
        this.updateSubmissionDropdown();
    });

    $scope.$on(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, (event, currentSubmission) => {
        const hasSubmissionIdChange = currentSubmission ? this.submissionId !== currentSubmission.id : false;

        this.updateSubmissionDropdown();

        if (hasSubmissionIdChange) {
            $state.go('submission.default', {submissionId: currentSubmission.id});
        }
    });

    $scope.$on(submissionConstant.event.CLOSE_SUBMISSION_MODULE, () => {
        $state.go('landing');
    });

    $scope.$on(coreConstant.event.REFRESH_RECENT_SUBMISSION_DROPDOWN, () => {
        this.updateSubmissionDropdown();
    });

    $scope.$on(coreConstant.event.CLOSE_SUBMISSION_VIEW, (event, submissionId) => {
        if (submissionId === this.submissionId) {
            handleCloseSubmission(submissionId);
        }
    });

    $scope.$on(submissionConstant.event.OPEN_SUBMISSION_LIST_CHANGE, () => {
        this.updateSubmissionDropdown();
    });
};

angular.module('gw-um-submission')
    .controller('activeSubmissionDropdownController', ActiveSubmissionDropdownController);
